import React from "react";
import { styled } from "styled-components";

import { ClosedChatFrame } from "./ClosedChatFrame";
import { textColorForBackground } from "./textColor";
import {
  AnnouncementColors,
  AnnouncementPlacement,
  AnnouncementPosition,
} from "./types";

const Card = styled.div<{ $border: string }>(({ $border, theme }) => ({
  padding: "12px 14px",
  maxWidth: 240,
  background: theme.colors.white,
  border: `1px solid ${$border}`,
  borderRadius: theme.radii[2],
  boxShadow: theme.shadows.surfaceZ1Light,
}));

const Description = styled.p({
  margin: 0,
  marginBottom: 8,
  color: "#1A1E23",
  fontSize: 14,
});

const Action = styled.a<{ $background: string; $color: string }>(
  ({ $background, $color, theme }) => ({
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    padding: "8px 12px",
    textAlign: "center",
    background: $background,
    color: $color,
    borderRadius: theme.radii[2],
    fontSize: 14,
    textDecoration: "none",
  }),
);

export interface CallToActionProps extends AnnouncementColors {
  description: string;
  buttonTitle: string;
  destinationLink: string;
  placement: AnnouncementPlacement;
  position?: AnnouncementPosition;
  onClick?: () => void;
  onDismiss?: () => void;
}

export const CallToAction: React.FC<CallToActionProps> = ({
  description,
  buttonTitle,
  destinationLink,
  placement,
  position = "right",
  primaryColor,
  secondaryColor,
  onClick,
  onDismiss,
}) => {
  return (
    <ClosedChatFrame
      placement={placement}
      position={position}
      onDismiss={onDismiss}
      label="Call to action"
    >
      <Card $border={primaryColor}>
        <Description>{description}</Description>
        <Action
          href={destinationLink}
          target="_blank"
          rel="noopener noreferrer"
          $background={secondaryColor}
          $color={textColorForBackground(secondaryColor)}
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          {buttonTitle}
        </Action>
      </Card>
    </ClosedChatFrame>
  );
};
